// 7.1.13 ToObject ( argument )
function ToObject(argument) { // eslint-disable-line no-unused-vars
	if (argument === null || argument === undefined) {
		throw TypeError();
	}
  return Object(argument);
}

// 7.3.5. CreateMethodProperty ( O, P, V )
function CreateMethodProperty(O, P, V) { // eslint-disable-line no-unused-vars
    // 1. Assert: Type(O) is Object.
    // 2. Assert: IsPropertyKey(P) is true.
    // 3. Let newDesc be the PropertyDescriptor{[[Value]]: V, [[Writable]]: true, [[Enumerable]]: false, [[Configurable]]: true}.
    var newDesc = {
        value: V,
        writable: true,
        enumerable: false,
        configurable: true
    };
    // 4. Return ? O.[[DefineOwnProperty]](P, newDesc).
    Object.defineProperty(O, P, newDesc);
}

if (!Object.prototype.values) {
    // call method above to polyfill Object.values
    CreateMethodProperty(Object, 'values', function values(O) {
        // 1. Let obj be ? ToObject(O).
        var obj = ToObject(O);
        // 2. Let nameList be ? EnumerableOwnProperties(obj, "value").
        var nameList = Object.keys(obj).map(function (key) {
            return obj[key];
        });
        // 3. Return CreateArrayFromList(nameList).
        // Polyfill.io - nameList is already an array.
        return nameList;
    });
}